import {
  IDynamicInput,
  IDynamicItem,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export class Icon implements IDynamicItem {
  public id: string;
  public readonly contentTypeId = 'dynamic-elements-icon';
  public styles = {
    style: {
      transform: `scale(1)`,
      'margin-top': `0px`,
      color: '#777777',
      'font-size': '30px',
    } as Exclude<
      Exclude<IDynamicItem['styles'], undefined>['style'],
      undefined
    >,
  };

  public inputs = {
    icon: [] as IDynamicInput,
  };

  constructor(id: string, icon: IDynamicInput) {
    this.id = id;
    this.inputs.icon = icon;
  }
}
